import http from '@/services/http';



const paymentGateway = {
  async load({ storeId, paymentLocationId }) {
    try {
      const response = await http.get(`/cardfree-api/v1/paymentgateways/${storeId}`);
      const gateway = paymentGateway.parse(response.data);
      gateway.storeId = storeId;

      if (paymentLocationId) {
        gateway.paymentLocationId = paymentLocationId;
      }

      else if (gateway.providers.Square) {
        const locationResponse = await http.get('/cardfree-api/v1/location/store', {
          params: {
            ids: storeId
          }
        });
        const fetchedLocation = locationResponse.data.data[0];
        gateway.paymentLocationId = fetchedLocation.paymentLocationId;
      }

      return gateway;
    }

    catch (error) {
      throw error;
    }
  },

  parse(gateways) {
    return gateways.reduce((result, gateway) => {
      result.providers[gateway.provider] = gateway;
      /* eslint-disable arrow-body-style */
      result.methods.applePay = gateways.find(g => g.paymentMethods.applePayEnabled);
      result.methods.creditCard = gateways.find(g => g.paymentMethods.creditCardsEnabled);
      result.methods.giftCard = gateways.find(g => g.paymentMethods.giftCardsEnabled);
      result.methods.googlePay = gateways.find(g => g.paymentMethods.googlePayEnabled);
      result.methods.massPayAch = gateways.find(g => g.paymentMethods.massPayAchEnabled);
      result.methods.roomCharge = gateways.find(g => g.paymentMethods.roomChargeEnabled);
      result.methods.savedCreditCard = gateways.find(g => g.paymentMethods.savedCreditCardsEnabled);
      /* eslint-enable arrow-body-style */
      return result;
    }, { methods: {}, providers: {} });
  }
};



export default paymentGateway;
